import { Button } from "@mui/material";
import { useState } from "react";
import { TextInput } from "../TextInput";
import PasswordStrengthBar from "react-password-strength-bar";
import useShowPassword from "../../hooks/useShowPassword";

const FormResetPassword = ({ values = {
  password: '',
  password_confirm: ''
}, error = {
  password: {
    error: '',
    msg: ''
  }
}, disabled = false, onChange, onSubmit, onChangeScore }) => {
  const [hoverSubmit, setHoverSubmit] = useState(false)

  const { onShowPassword, showPassword } = useShowPassword({
    typePassword: 'password',
    typePasswordConfirm: 'password_confirm',
  });

  return (
    <>
      <TextInput
        label="Kata Sandi Baru"
        value={values.password}
        error={error.password.error}
        error_msg={error.password.msg}
        onChange={onChange}
        placeholder="Masukan Kata Sandi"
        type="password"
        name="password"
        show={showPassword.password}
        onShow={onShowPassword}
      />
      {values.password.length > 0 ? (
        <PasswordStrengthBar
          password={values.password}
          scoreWords={[
            'Perhatian! Kata sandi harus mengandung Huruf besar,kecil dan angka',
            'Buruk',
            'Kurang baik',
            'Sangat baik',
            'Sempurna',
          ]}
          onChangeScore={onChangeScore}
        />
      ) : (
        <></>
      )}
      <div className="mt-2"></div>
      <TextInput
        label="Ulangi Kata Sandi Baru"
        value={values.password_confirm}
        error={error.password_confirm.error}
        error_msg={error.password_confirm.msg}
        onChange={onChange}
        placeholder="Masukan Kata Sandi Baru"
        type="password"
        name="password_confirm"
        show={showPassword.password_confirm}
        onShow={onShowPassword}
      />
      {values.password_confirm.length > 0 && (
        <PasswordStrengthBar
          password={values.password}
          scoreWords={[
            'Perhatian! Kata sandi harus mengandung Huruf besar,kecil dan angka',
            'Buruk',
            'Kurang baik',
            'Sangat baik',
            'Sempurna',
          ]}
          onChangeScore={onChangeScore}
        />
      )}

      <Button variant={hoverSubmit ? 'outlined' : 'contained'}
        color='primaryMAP'
        fullWidth
        sx={{
          marginTop: '10px'
        }}
        disabled={disabled} onClick={onSubmit}
        onMouseLeave={() => setHoverSubmit(false)} onMouseEnter={() => setHoverSubmit(true)}>
        Atur Ulang Kata Sandi Baru
      </Button>
    </>
  );
}

export default FormResetPassword;